export default "<div class=\"share-btn-container\">\n  <ion-icon name=\"share-social-outline\"></ion-icon>\n</div>\n";